// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__iSjDb","spin":"styles_spin__30lth"};